var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7C7.25 4.381 9.381 2.25 12 2.25C14.619 2.25 16.75 4.381 16.75 7C16.75 9.619 14.619 11.75 12 11.75C9.381 11.75 7.25 9.619 7.25 7ZM15 13.25H9C5.83 13.25 3.25 15.83 3.25 19C3.25053 19.7292 3.54043 20.4283 4.05604 20.944C4.57165 21.4596 5.27082 21.7495 6 21.75H18C18.7292 21.7495 19.4283 21.4596 19.944 20.944C20.4596 20.4283 20.7495 19.7292 20.75 19C20.75 15.83 18.17 13.25 15 13.25Z",
    fill: "#8345E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurple);
export default __webpack_public_path__ + "static/media/User Purple.ee5faa038f033cf7d9244f2cf8105a63.svg";
export { ForwardRef as ReactComponent };